type CompleteIndicatorProps = {
    isCompleted: boolean;
};

export default function CompleteIndicator({ isCompleted }: CompleteIndicatorProps): JSX.Element {
    return <div className={`h-2 w-2 rounded-full ${isCompleted ? 'bg-green-500' : 'bg-gray-300'} shrink-0`}></div>;
}
